import React from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PetsIcon from '@mui/icons-material/Pets';
import QrCodeIcon from '@mui/icons-material/QrCode';
import SecurityIcon from '@mui/icons-material/Security';

const HomePage = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <PetsIcon sx={{ fontSize: 40 }} />,
      title: '반려동물 관리',
      description: '반려동물의 정보를 체계적으로 관리하고 의료 기록을 손쉽게 저장할 수 있습니다.'
    },
    {
      icon: <QrCodeIcon sx={{ fontSize: 40 }} />,
      title: 'NFC 태그',
      description: 'NFC 태그를 통해 반려동물의 정보를 빠르고 안전하게 확인할 수 있습니다.'
    },
    {
      icon: <SecurityIcon sx={{ fontSize: 40 }} />,
      title: '안전한 보호',
      description: '반려동물이 길을 잃어도 NFC 태그를 통해 빠르게 보호자에게 연락할 수 있습니다.'
    }
  ];

  return (
    <Box>
      {/* 히어로 섹션 */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          py: 8,
          mb: 6
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h2"
            component="h1"
            sx={{
              mb: 4,
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            Pet NFC Tag
          </Typography>
          <Typography
            variant="h5"
            sx={{
              mb: 4,
              textAlign: 'center'
            }}
          >
            NFC 기술로 더 안전하게 반려동물을 보호하세요
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: 2
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              size="large"
              onClick={() => navigate('/register')}
            >
              시작하기
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              size="large"
              onClick={() => navigate('/about')}
            >
              자세히 알아보기
            </Button>
          </Box>
        </Container>
      </Box>

      {/* 특징 섹션 */}
      <Container maxWidth="lg" sx={{ mb: 8 }}>
        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  p: 3
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mb: 2,
                    color: 'primary.main'
                  }}
                >
                  {feature.icon}
                </Box>
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    sx={{ textAlign: 'center' }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ textAlign: 'center' }}
                  >
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* 하단 CTA 섹션 */}
      <Box
        sx={{
          bgcolor: 'grey.100',
          py: 6
        }}
      >
        <Container maxWidth="sm">
          <Typography
            variant="h4"
            component="h2"
            sx={{
              mb: 4,
              textAlign: 'center'
            }}
          >
            지금 바로 시작하세요
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => navigate('/register')}
            >
              무료로 시작하기
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default HomePage; 